import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Quote } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 bg-brown text-cream relative overflow-hidden" data-id="element-89">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-90"></div>

      {/* Decorative large quote mark */}
      <div className="absolute top-10 left-10 text-gold/5 font-serif text-[200px] leading-none select-none pointer-events-none" data-id="element-91">
        "
      </div>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center relative z-10" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-93">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gold/10 mb-8 border-2 border-gold text-gold animate-pulse" data-id="element-94">
            <ShieldCheck className="w-12 h-12" data-id="element-95" />
          </div>

          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-8" data-id="element-96">
            Garantía Total de 30 Días
          </h2>

          <div className="w-full h-[1px] bg-gold/30 mb-8" data-id="element-97"></div>

          <p className="text-xl text-cream/90 font-sans leading-relaxed mb-10 font-light" data-id="element-98">
            Si en 30 días no estás satisfecha con los resultados, te devolvemos
            el 100% de tu inversión. Sin preguntas. Sin complicaciones. Así de
            seguros estamos de que esto funciona para ti.
          </p>

          <p className="text-lg text-gold font-serif italic" data-id="element-99">
            Tu confianza vale más que $6.36.
          </p>
        </motion.div>
      </div>
    </section>;
}